"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SectionalInfoCard = function SectionalInfoCard(props) {
  var mainLabel = props.mainLabel,
    data = props.data,
    isLoaded = props.isLoaded;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h3", {
    className: "card-main-title"
  }, mainLabel), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Card, {
    fluid: true
  }, isLoaded ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _lodash.default.map(data, function (cardSection, index) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Card.Content, {
      id: "sectionalheader-".concat(index),
      header: cardSection.label
    }), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Card.Content, {
      id: "sectional-".concat(index),
      className: "fixed-height-container"
    }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _lodash.default.map(cardSection.data, function (item, index) {
      return /*#__PURE__*/_react.default.createElement(_semanticUiReact.List.Item, {
        key: index
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "card-content ".concat(_lodash.default.snakeCase(item.label))
      }, /*#__PURE__*/_react.default.createElement("strong", {
        className: "card-sub-title"
      }, item.label), /*#__PURE__*/_react.default.createElement("br", null), item.value ? item.value : '--'));
    }))));
  })) : /*#__PURE__*/_react.default.createElement(_semanticUiReact.Card.Content, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Loader, {
    inline: "centered",
    active: true
  }, "Loading..."))));
};
var _default = SectionalInfoCard;
exports.default = _default;